<script setup lang="ts">
import { onMounted, watch } from 'vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import LoginView from '@/views/LoginView.vue'
import ToastStack from '@/components/ToastStack.vue'
import { useAuthStore } from '@/stores/auth'
import { useAppDataStore } from '@/stores/app-data'
import { useUiStore } from '@/stores/ui'

const auth = useAuthStore()
const data = useAppDataStore()
const ui = useUiStore()

onMounted(async () => {
  await auth.restore()
})

watch(() => auth.user, async user => {
  if (!user) return
  try {
    await data.load()
  } catch (error) {
    ui.toast(error instanceof Error ? error.message : '应用数据加载失败', 'error')
  }
}, { immediate: true })
</script>

<template>
  <div v-if="!auth.ready" class="loading-screen"><div class="loading-stack"><div class="spinner"></div><span>正在恢复登录状态...</span></div></div>
  <LoginView v-else-if="!auth.user" />
  <div v-else-if="data.loading && !data.loaded" class="loading-screen"><div class="loading-stack"><div class="spinner"></div><span>正在加载经营数据...</span></div></div>
  <AdminLayout v-else />
  <ToastStack />
</template>
